// Translations
import landing from '../views/landing/translations/ar'

// Translation: Error (Arabic)
export default Object.freeze({
	name: 'خطأ',
	views: { landing }
})
